import { render } from "./Title.vue?vue&type=template&id=4b500bac&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=4b500bac&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b500bac"]])

export default __exports__